<template>
  <footer class="na-footer">
    <div class="na-wrap">
      <div class="footer-grid">
        <div class="footer-brand">
          <router-link to="/" class="footer-logo" aria-label="NewsAppify home">
            <span class="na-seal footer-seal">N</span>
            <span class="na-wordmark footer-wordmark">News<span>Appify</span></span>
          </router-link>
          <p class="footer-about">
            Your town's newspaper as iPhone and Android apps, a website and email newsletters —
            built for you, branded as yours, and run from one newsroom.
          </p>
        </div>

        <div>
          <h4 class="footer-heading">Company</h4>
          <ul class="footer-links">
            <li><router-link to="/why">Why NewsAppify</router-link></li>
            <li><router-link to="/features">Features</router-link></li>
            <li><router-link to="/advertising">Advertising &amp; Revenue</router-link></li>
            <li><router-link to="/about">About Us</router-link></li>
            <li><router-link to="/blog">Blog</router-link></li>
            <li><a href="https://tribzz.com" target="_blank" rel="noopener" class="tz-link">Tribzz <span>18+</span> ↗</a></li>
          </ul>
        </div>

        <div>
          <h4 class="footer-heading">Support</h4>
          <ul class="footer-links">
            <li><router-link to="/documentation">Documentation</router-link></li>
            <li><router-link to="/help">Help Center</router-link></li>
            <li><router-link to="/contact">Contact Us</router-link></li>
            <li><router-link to="/demo">Request Demo</router-link></li>
            <li><router-link to="/login">Client Portal</router-link></li>
          </ul>
        </div>

        <div>
          <h4 class="footer-heading">Legal</h4>
          <ul class="footer-links">
            <li><router-link to="/privacy">Privacy Policy</router-link></li>
            <li><router-link to="/terms">Terms of Service</router-link></li>
            <li><router-link to="/cookies">Cookie Policy</router-link></li>
            <li><router-link to="/security">Security</router-link></li>
          </ul>
        </div>

        <div>
          <h4 class="footer-heading">Contact</h4>
          <ul class="footer-contact">
            <li><v-icon small color="#B8925A">mdi-email-outline</v-icon><a href="mailto:mike@newsappify.com">mike@newsappify.com</a></li>
            <li><v-icon small color="#B8925A">mdi-phone-outline</v-icon><a href="tel:+17812994999">(781) 299-4999</a></li>
            <li><v-icon small color="#B8925A">mdi-map-marker-outline</v-icon><span>United States</span></li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© {{ year }} NewsAppify. All rights reserved.</p>
        <p class="footer-meta">Made in the USA <span aria-hidden="true">✦</span> Empowering local journalism</p>
      </div>
    </div>
  </footer>
</template>

<script>
import '@/assets/na-theme.css'

export default {
  name: 'AppFooter',
  computed: { year: () => new Date().getFullYear() },
}
</script>

<style scoped>
.na-footer {
  background: var(--na-navy-deep, #0B1E3B);
  color: rgba(243, 238, 227, 0.72);
  padding: 80px 0 30px;
  font-family: var(--na-sans, 'Libre Franklin', sans-serif);
  border-top: 4px solid var(--na-brass, #B8925A);
}
.footer-grid {
  display: grid;
  grid-template-columns: 1.7fr 1fr 1fr 1fr 1.5fr;
  gap: 40px;
  padding-bottom: 52px;
  border-bottom: 1px solid rgba(243, 238, 227, 0.14);
}
.footer-logo { display: inline-flex; align-items: center; gap: 12px; text-decoration: none; margin-bottom: 20px; }
.footer-seal { background: var(--na-brass, #B8925A); color: var(--na-navy-deep, #0B1E3B); box-shadow: inset 0 0 0 3px var(--na-brass, #B8925A), inset 0 0 0 4.5px rgba(11, 30, 59, 0.5); }
.footer-seal::after { background: #fff; border-color: var(--na-navy-deep, #0B1E3B); }
.footer-wordmark { color: #fff; }
.footer-about { font-family: var(--na-serif, Georgia, serif); font-size: 1.05rem; line-height: 1.65; margin: 0; max-width: 28em; }
.footer-heading {
  font-family: var(--na-sans, sans-serif);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--na-brass, #B8925A);
  margin: 4px 0 18px;
}
.footer-links, .footer-contact { list-style: none; padding: 0; margin: 0; }
.footer-links li { margin-bottom: 11px; }
.footer-links a { color: rgba(243, 238, 227, 0.78); text-decoration: none; font-size: 0.97rem; transition: color 0.15s ease; }
.footer-links a:hover { color: #fff; }
.footer-links .tz-link span { margin: 0 2px; padding: 1px 5px; border: 1px solid rgba(184, 146, 90, 0.6); border-radius: 3px; font-size: 0.7rem; color: var(--na-brass, #B8925A); }
.footer-contact li { display: flex; align-items: center; gap: 10px; margin-bottom: 13px; font-size: 0.95rem; }
.footer-contact a { color: rgba(243, 238, 227, 0.85); text-decoration: none; word-break: break-all; }
.footer-contact a:hover { color: #fff; }
.footer-bottom { display: flex; justify-content: space-between; flex-wrap: wrap; gap: 8px 24px; padding-top: 26px; font-size: 0.9rem; color: rgba(243, 238, 227, 0.5); }
.footer-bottom p { margin: 0; }
.footer-meta span { color: var(--na-brass, #B8925A); margin: 0 6px; }
.na-footer a:focus-visible { outline: 3px solid var(--na-brass, #B8925A); outline-offset: 2px; }
@media (max-width: 960px) {
  .footer-grid { grid-template-columns: 1fr 1fr 1fr; }
  .footer-brand { grid-column: 1 / -1; }
}
@media (max-width: 560px) {
  .footer-grid { grid-template-columns: 1fr 1fr; gap: 32px 20px; }
  .footer-grid > div:last-child { grid-column: 1 / -1; }
}
</style>